import React from "react";
import "./PracticeByCoursesTab.scss";

// image imports
import CardCourseIcon from "assets/images/bidding_basic.svg";
import InteractiveIcon from "assets/images/interactiveBidding.png";
import CourseItem from "common/components/CourseItem";
import { showMobile } from "helpers/adaptation";
import PracticeByCoursesTabMobile from "./PracticeByCoursesTabMobile";
import PracticeBiddingAllExercises from "./PracticeBiddingAllExercises";
import PracticePackagesExercises from "./PracticePackagesExercises";
import { BiddingEnum } from "enums/enums";
import { ICourseValue } from "types/common";

interface Props {
  data?: any[];
  onPressItem?: (
    val: ICourseValue,
    type: BiddingEnum.INTERACTIVE_BIDDING | BiddingEnum.BIDDING,
    isBidPlay: boolean
  ) => void;
  searchData?: any[];
  isFirstTab?: boolean;
  searchText?: string;
  valKey?: any;
}

function PracticeByCoursesTab({
  data,
  valKey,
  onPressItem,
  searchData,
  isFirstTab,
  searchText
}: Props) {
  if (valKey === "60") {
    return <PracticeBiddingAllExercises data={data} searchText={searchText} />;
  }

  if (valKey === "70") {
    return <PracticePackagesExercises data={data} searchText={searchText} />;
  }

  return (
    <>
      {showMobile && (
        <PracticeByCoursesTabMobile
          {...{ data, onPressItem, searchData, isFirstTab, searchText, valKey }}
        />
      )}
      {!showMobile && (
        <div className={`PracticeByCourses-main ${isFirstTab ? "FirstTab-main" : ""}`}>
          <div className="PracticeByCoursesTab-ul">
            {searchData && searchText && (
              <div className="practiceByCoursesTab-ul-container practiceByCoursesTab-ul-container-search">
                {searchData.map((val, index) => {
                  if (val === null) {
                    return null;
                  }

                  const isDisabled = !val?.isEnabled;
                  return (
                    <CourseItem
                      key={`${val.Data?.Id_Course}_${index}_${val?.Data?.CourseKey}`}
                      onPressItem={
                        onPressItem
                          ? () =>
                              onPressItem(
                                val,
                                val?.IsInteractive
                                  ? BiddingEnum.INTERACTIVE_BIDDING
                                  : BiddingEnum.BIDDING,
                                !!val?.BidPlay
                              )
                          : undefined
                      }
                      isInteractive={val?.IsInteractive}
                      title={val.Name}
                      img={val?.IsInteractive ? InteractiveIcon : CardCourseIcon}
                      isBidPlay={!!val?.BidPlay}
                      isDisabled={isDisabled}
                    />
                  );
                })}
              </div>
            )}
            {searchText?.length === 0 && (
              <div
                className="practiceByCoursesTab-ul-container"
                style={{
                  justifyContent: "space-between"
                }}>
                {data?.map((itemCourse, index) => {
                  return (
                    <div key={`${index}_${itemCourse?.Index}`}>
                      {itemCourse?.courses?.map((val: any, indexItemCourse: number) => {
                        if (val === null) {
                          return (
                            <div
                              key={indexItemCourse}
                              className="list-item-courses-bidding"
                              style={{ opacity: 0 }}></div>
                          );
                        }
                        if (!val?.IsDisplay) {
                          return null;
                        }

                        const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
                        return (
                          <CourseItem
                            key={`${val.Id}${val.CourseId}${val?.ParentSubject}${indexItemCourse}`}
                            onPressItem={
                              !isDisabled && onPressItem
                                ? () =>
                                    onPressItem(
                                      val,
                                      val?.IsInteractive
                                        ? BiddingEnum.INTERACTIVE_BIDDING
                                        : BiddingEnum.BIDDING,
                                      !!val?.BidPlay
                                    )
                                : undefined
                            }
                            isInteractive={val?.IsInteractive}
                            isDisabled={isDisabled}
                            title={val.Name}
                            img={val?.IsInteractive ? InteractiveIcon : CardCourseIcon}
                            isBidPlay={!!val?.BidPlay}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default PracticeByCoursesTab;
